export const formControlAutofillClasses = [
    'autofill:![box-shadow:inset_0_0_0_1000px_var(--color-surface),var(--tw-ring-shadow,0_0_#0000)] [&:-webkit-autofill]:![-webkit-box-shadow:inset_0_0_0_1000px_var(--color-surface),var(--tw-ring-shadow,0_0_#0000)]',
    'dark:autofill:![box-shadow:inset_0_0_0_1000px_var(--color-surface-dark),var(--tw-ring-shadow,0_0_#0000)] dark:[&:-webkit-autofill]:![-webkit-box-shadow:inset_0_0_0_1000px_var(--color-surface-dark),var(--tw-ring-shadow,0_0_#0000)]',
    'disabled:autofill:![box-shadow:inset_0_0_0_1000px_var(--color-field-disabled-bg),var(--tw-ring-shadow,0_0_#0000)] disabled:[&:-webkit-autofill]:![-webkit-box-shadow:inset_0_0_0_1000px_var(--color-field-disabled-bg),var(--tw-ring-shadow,0_0_#0000)]',
    'dark:disabled:autofill:![box-shadow:inset_0_0_0_1000px_var(--color-field-disabled-bg-dark),var(--tw-ring-shadow,0_0_#0000)] dark:disabled:[&:-webkit-autofill]:![-webkit-box-shadow:inset_0_0_0_1000px_var(--color-field-disabled-bg-dark),var(--tw-ring-shadow,0_0_#0000)]',
    'autofill:text-fg [&:-webkit-autofill]:[-webkit-text-fill-color:var(--color-fg)] [&:-webkit-autofill]:caret-fg',
    'dark:autofill:text-fg-dark dark:[&:-webkit-autofill]:[-webkit-text-fill-color:var(--color-fg-dark)] dark:[&:-webkit-autofill]:caret-fg-dark'
];

export const formControlSurfaceClasses = [
    'rounded-[8px] border border-border-strong bg-transparent text-fg placeholder:text-fg-faint',
    '[transition:border-color_.1s,box-shadow_.1s] hover:border-[color-mix(in_srgb,var(--color-accent)_55%,var(--color-border-strong))]',
    'dark:border-border-strong-dark dark:text-fg-dark dark:placeholder:text-fg-faint-dark',
    'dark:hover:border-[color-mix(in_srgb,var(--color-accent)_55%,var(--color-border-strong-dark))]',
    ...formControlAutofillClasses
];

export const formControlFocusClasses = 'focus:border-accent focus:outline-none focus:ring-[3px] focus:ring-[color-mix(in_oklch,var(--color-accent)_20%,transparent)]';

export const formControlFocusWithinClasses = 'focus-within:border-accent focus-within:outline-none focus-within:ring-[3px] focus-within:ring-[color-mix(in_oklch,var(--color-accent)_20%,transparent)]';

export const formControlDisabledValueClasses = [
    'disabled:!text-field-disabled-fg disabled:placeholder:!text-field-disabled-icon',
    'disabled:![-webkit-text-fill-color:var(--color-field-disabled-fg)] disabled:placeholder:![-webkit-text-fill-color:var(--color-field-disabled-icon)]',
    'dark:disabled:!text-field-disabled-fg-dark dark:disabled:placeholder:!text-field-disabled-icon-dark',
    'dark:disabled:![-webkit-text-fill-color:var(--color-field-disabled-fg-dark)] dark:disabled:placeholder:![-webkit-text-fill-color:var(--color-field-disabled-icon-dark)]'
];

export const formControlDisabledIconClasses = 'disabled:[&_svg]:!text-field-disabled-icon disabled:[&_svg]:!opacity-100 dark:disabled:[&_svg]:!text-field-disabled-icon-dark';

export const formControlDisabledClasses = [
    'disabled:cursor-not-allowed disabled:!border-field-disabled-border disabled:!bg-field-disabled-bg',
    'disabled:!opacity-100 disabled:hover:!border-field-disabled-border disabled:hover:shadow-none',
    'dark:disabled:!border-field-disabled-border-dark dark:disabled:!bg-field-disabled-bg-dark',
    'dark:disabled:hover:!border-field-disabled-border-dark',
    ...formControlDisabledValueClasses,
    formControlDisabledIconClasses
];

export const formControlDisabledSurfaceClasses = [
    '!border-field-disabled-border !bg-field-disabled-bg !text-field-disabled-fg',
    'dark:!border-field-disabled-border-dark dark:!bg-field-disabled-bg-dark dark:!text-field-disabled-fg-dark'
];

export const formChoiceDisabledClasses = 'disabled:!opacity-100 disabled:!border-field-disabled-border disabled:!bg-field-disabled-bg disabled:checked:!border-field-disabled-fg disabled:checked:!bg-field-disabled-fg disabled:indeterminate:!border-field-disabled-fg disabled:indeterminate:!bg-field-disabled-fg dark:disabled:!border-field-disabled-border-dark dark:disabled:!bg-field-disabled-bg-dark dark:disabled:checked:!border-field-disabled-fg-dark dark:disabled:checked:!bg-field-disabled-fg-dark dark:disabled:indeterminate:!border-field-disabled-fg-dark dark:disabled:indeterminate:!bg-field-disabled-fg-dark';

export const formControlReadonlyClasses = [
    'enabled:read-only:cursor-default enabled:read-only:bg-transparent enabled:read-only:text-fg',
    'dark:enabled:read-only:text-fg-dark'
];

export const formChoiceRowBaseClasses = 'group rounded-[8px] text-ui-body/normal font-[400] text-fg select-none [transition:background_.15s] dark:text-fg-dark [&:has(input:disabled)]:!text-field-disabled-fg dark:[&:has(input:disabled)]:!text-field-disabled-fg-dark';

export const formChoiceRowInteractiveClasses = 'cursor-pointer hover:bg-hover dark:hover:bg-hover-dark';

export const formChoiceRowDisabledClasses = 'cursor-not-allowed !text-field-disabled-fg dark:!text-field-disabled-fg-dark';

export const formControlCompoundClasses = [
    'overflow-hidden rounded-[8px] border border-border-strong bg-transparent dark:border-border-strong-dark',
    '[transition:border-color_.1s,box-shadow_.1s]',
    formControlFocusWithinClasses
];

export const formControlGroupFocusClasses = [
    formControlFocusWithinClasses,
    '[&:focus-within_.ideo-form-control-part]:border-accent'
];

export const formControlGroupPartClasses = 'ideo-form-control-part focus:outline-none';

export const formEmbeddedInputClasses = [
    'ideo-form-control block h-[30px] w-full rounded-none border-0 bg-transparent px-[10px] py-0 text-ui-body/normal font-[400] text-fg',
    'placeholder:text-fg-faint focus:outline-none focus:ring-0 dark:text-fg-dark dark:placeholder:text-fg-faint-dark',
    ...formControlAutofillClasses,
    ...formControlDisabledClasses
];

export const formInputClasses = [
    'ideo-form-control ideo-form-input block h-[30px] px-[10px] py-0 text-ui-body/normal font-[400]',
    ...formControlSurfaceClasses,
    formControlFocusClasses,
    ...formControlDisabledClasses,
    ...formControlReadonlyClasses
];

export const formInputSizeClasses = {
    sm: 'px-[8px] text-[0.78125rem]',
    md: 'px-[10px] text-ui-body',
    lg: 'px-[14px] text-[0.875rem]'
};

export const formTextareaClasses = [
    'ideo-form-control block h-auto min-h-[80px] w-full resize-y px-[10px] py-[8px] text-ui-body/normal font-[400]',
    ...formControlSurfaceClasses,
    formControlFocusClasses,
    ...formControlDisabledClasses,
    ...formControlReadonlyClasses
];

export const formSelectClasses = [
    'ideo-form-select flex h-[30px] min-h-[30px] min-w-0 max-w-full w-full items-center justify-between gap-[8px] px-[10px] py-0 text-start text-ui-body/normal font-[400]',
    ...formControlSurfaceClasses,
    formControlFocusClasses,
    ...formControlDisabledClasses
];

export const formControlTriggerClasses = [
    'ideo-form-control flex h-[30px] min-h-[30px] w-full items-center px-[10px] py-0 text-ui-body/normal font-[400]',
    ...formControlSurfaceClasses,
    formControlFocusClasses,
    ...formControlDisabledClasses
];

export const formControlGroupTriggerClasses = [
    'ideo-form-control ideo-form-control-part flex h-[30px] min-h-[30px] w-full items-center px-[10px] py-0 text-ui-body/normal font-[400]',
    ...formControlSurfaceClasses,
    ...formControlDisabledClasses
];

export const formDatetimeInputClasses = [
    'ideo-form-control ideo-datetime-input h-[30px] w-full py-0 ps-[30px] pe-[10px] font-[inherit] text-ui-body/normal font-[400]',
    ...formControlSurfaceClasses,
    formControlFocusClasses,
    ...formControlDisabledClasses
];

export const formControlInvalidClasses = [
    '[&_.ideo-input-group-affix]:border-danger dark:[&_.ideo-input-group-affix]:border-danger-dark [&_.ideo-input-group-affix:focus-within]:ring-[3px] [&_.ideo-input-group-affix:focus-within]:ring-[color-mix(in_oklch,var(--color-danger)_18%,transparent)]',
    '[&_.ideo-form-control:not(.valid)]:border-danger [&_.ideo-form-select:not(.valid)]:border-danger',
    '[&_.ideo-form-check-input:not(.valid)]:border-danger [&_.ideo-form-radio-input:not(.valid)]:border-danger',
    '[&_.editor.tiptap-editor]:border-danger [&_.multiselect__tags]:border-danger',
    '[&_.ideo-form-control:not(.valid):focus]:ring-[3px] [&_.ideo-form-control:not(.valid):focus]:ring-[color-mix(in_oklch,var(--color-danger)_18%,transparent)]',
    'dark:[&_.ideo-form-control:not(.valid)]:border-danger-dark dark:[&_.ideo-form-select:not(.valid)]:border-danger-dark',
    'dark:[&_.ideo-form-check-input:not(.valid)]:border-danger-dark dark:[&_.ideo-form-radio-input:not(.valid)]:border-danger-dark',
    'dark:[&_.editor.tiptap-editor]:border-danger-dark dark:[&_.multiselect__tags]:border-danger-dark'
];

export const formControlValidClasses = [
    'valid border-success focus:border-success focus:ring-[3px] focus:ring-[color-mix(in_oklch,var(--color-success)_22%,transparent)]',
    'dark:border-success-dark dark:focus:border-success-dark'
];

export const formMultiselectFocusClasses = '[&:focus-within_.multiselect__tags]:border-accent [&:focus-within_.multiselect__tags]:outline-none [&:focus-within_.multiselect__tags]:ring-[3px] [&:focus-within_.multiselect__tags]:ring-[color-mix(in_oklch,var(--color-accent)_20%,transparent)]';

export const formScheduleXFocusClasses = [
    '[&_.sx__date-input--active_.sx__date-input]:border-accent [&_.sx__date-input--active_.sx__date-input]:outline-none',
    '[&_.sx__date-input--active_.sx__date-input]:ring-[3px] [&_.sx__date-input--active_.sx__date-input]:ring-[color-mix(in_oklch,var(--color-accent)_20%,transparent)]',
    '[&_.sx__date-picker__day:focus]:border-accent [&_.sx__date-picker__day:focus]:outline-none',
    '[&_.sx__date-picker__day:focus]:ring-[3px] [&_.sx__date-picker__day:focus]:ring-[color-mix(in_oklch,var(--color-accent)_20%,transparent)]'
];
